(() => {
    class Page extends App.Entities.Base {
        constructor() {
            super();

            /**
             * Page URI
             * @type {string}
             */
            this.url = window.location.pathname;
            /**
             * Page title
             * @type {string}
             */
            this.title = document.title;
            /**
             * Page content
             * If content is empty it sets the actual content for this page
             * @type {string|string}
             */
            this.content = document.getElementById('content') ? document.getElementById('content').innerHTML : '';
            /**
             * Scroll position in PX
             * @type {number}
             */
            this.position = 0;
            /**
             * Static or dynamic
             * Static: Page load information once an do not reload again
             * Dynamic: Page reloads every time to keep data updated (ex. forms, personal data)
             * @type {string}
             */
            this.type = 'static';
            /**
             * Brand of the page to display, this helps to define styling.
             * @type {string}
             */
            this.brand = 'mymuesli';
            /**
             * List of CSS resources to load in relation to the page
             * @type {*[]}
             */
            this.cssResources = [];
            /**
             * List of JS resources to load in relation to the page
             * @type {*[]}
             */
            this.jsResources = [];
            /**
             * List of overlay Buttons
             * @type {*[]}
             */
            this.buttons = [];
            /**
             * Like an expando, the page can send variables to apply in the overlay
             * @type {{}}
             */
            this.variables = {};
            /**
             * Layout of overlay, for example we can signalize to the popup to be `full` or `floating`
             * @type {string}
             */
            this.overlayLayout = 'default';
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        setContent(content) {
            this.content = content;
            return this;
        }

        setButton(button) {
            this.buttons.push(button);
            return this;
        }
    }
    App.Entities.Page = Page;
})();
